import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Customer } from 'TimelogDataTypes';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private http: HttpClient) {}

  getCustomers(): Observable<Customer[]> {
    return this.http.get<Customer[]>('/api/Customer');
  }

  updateCustomer(customer: Customer): Observable<Customer> {
    return this.http.put<Customer>('/api/Customer', customer);
  }

  deleteCustomer(id: number): Observable<Customer> {
    return this.http.delete<Customer>('/api/Customer/' + id);
  }
}
